import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Wallet from './pages/Wallet';
import Withdraw from './pages/Withdraw';
import Transfer from './pages/Transfer';
import Store from './pages/Store';
import Coupons from './pages/Coupons';
import CouponConfirmation from './pages/CouponConfirmation';
import VideoReels from './video/pages/VideoReels';
import VideoPost from './pages/VideoPost';
import ProfilePage from './profileuser/pages/ProfilePage';
import UserVideoFeed from './video/pages/UserVideoFeed';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Header from './components/Header';

function AppContent() {
  const user = localStorage.getItem('user');
  const location = useLocation();
  const hideHeaderPaths = ['/videoreel', '/user/*/videos'];

  // Check if header should be hidden for current path
  const shouldHideHeader = hideHeaderPaths.some(path => {
    if (path.includes('*')) {
      const regex = new RegExp(path.replace('*', '.*'));
      return regex.test(location.pathname);
    }
    return path === location.pathname;
  });

  return (
    <>
      {!shouldHideHeader && <Header />}
      <main className={!shouldHideHeader ? "pt-16" : ""}>
        <Routes>
          {/* Redirect root to videoreel if authenticated, otherwise show landing */}
          <Route path="/" element={
            user ? <Navigate to="/videoreel" replace /> : <Landing />
          } />

          {/* Public routes */}
          <Route path="/login" element={
            <PublicRoute><Login /></PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute><Register /></PublicRoute>
          } />

          {/* Protected routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          <Route path="/wallet" element={
            <ProtectedRoute><Wallet /></ProtectedRoute>
          } />
          <Route path="/withdraw" element={
            <ProtectedRoute><Withdraw /></ProtectedRoute>
          } />
          <Route path="/transfer" element={
            <ProtectedRoute><Transfer /></ProtectedRoute>
          } />
          <Route path="/store" element={
            <ProtectedRoute><Store /></ProtectedRoute>
          } />
          <Route path="/coupons" element={
            <ProtectedRoute><Coupons /></ProtectedRoute>
          } />
          <Route path="/coupon-confirmation" element={
            <ProtectedRoute><CouponConfirmation /></ProtectedRoute>
          } />
          <Route path="/videoreel" element={
            <ProtectedRoute><VideoReels /></ProtectedRoute>
          } />
          <Route path="/video/:id" element={
            <ProtectedRoute><VideoPost /></ProtectedRoute>
          } />
          <Route path="/profile/:userId" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/user/:userId/videos" element={
            <ProtectedRoute><UserVideoFeed /></ProtectedRoute>
          } />

          {/* Catch-all Redirect */}
          <Route path="*" element={
            user ? <Navigate to="/videoreel" replace /> : <Navigate to="/" replace />
          } />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <AppContent />
    </Router>
  );
}

export default App;